import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import imageUrl from '../../../images/StudyCalculatorImg.webp';
const TITLE = 'Convert GPA to Malaysian Grading System';
const DESCRIPTION = 'Discover how to convert your GPA to the Malaysian grading system with ease and accuracy. Learn the details of the Malaysian university grading system.';
const KEYWORDS = 'Malaysian university system, GPA conversion, Malaysian grading system, bachelor GPA, master GPA, university GPA, Malaysia';
const OG_URL = 'https://do-calculate.com/calculator/en/gradetomalaysia';
function GpaToMalaysia() {
  const [originalValue, setOriginalValue] = useState('');
  const [convertedValue, setConvertedValue] = useState('');
  const [conversionType, setConversionType] = useState('grade');
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const percentageToGpa = (percentage) => {
    if (percentage >= 93 && percentage <= 96) {
      return 4.0;
    } else if (percentage >= 90 && percentage <= 92) {
      return 3.67;
    } else if (percentage >= 87 && percentage <= 89) {
      return 3.33;
    } else if (percentage >= 83 && percentage <= 86) {
      return 3.00;
    } else if (percentage >= 80 && percentage <= 82) {
      return 2.67;
    } else if (percentage >= 77 && percentage <= 79) {
      return 2.33;
    } else if (percentage >= 73 && percentage <= 76) {
      return 2.00;
    } else if (percentage >= 70 && percentage <= 72) {
      return 1.67;
    } else if (percentage >= 67 && percentage <= 69) {
      return 1.33;
    } else if (percentage >= 65 && percentage <= 66) {
      return 1.00;
    } else if (percentage >= 0 && percentage <= 64) {
      return 0.0;
    } else {
      return 'Invalid input';
    }
  };
  const gpaToMalaysianGrade = (gpa) => {
    if (gpa === 4.0) {
      return 'A';
    } else if (gpa === 3.67) {
      return 'A-';
    } else if (gpa === 3.33) {
      return 'B+';
    } else if (gpa === 3.00) {
      return 'B';
    } else if (gpa === 2.67) {
      return 'B-';
    } else if (gpa === 2.33) {
      return 'C+';
    } else if (gpa === 2.00) {
      return 'C';
    } else if (gpa === 1.67) {
      return 'C-';
    } else if (gpa === 1.33) {
      return 'D+';
    } else if (gpa === 1.00) {
      return 'D';
    } else if (gpa === 0.0) {
      return 'F';
    } else {
      return 'Invalid input';
    }
  };
  const calculateConversion = (value) => {
    if (conversionType === 'grade') {
      const percentage = parseFloat(value);
      if (!isNaN(percentage) && percentage >= 0 && percentage <= 100) {
        const gpa = percentageToGpa(percentage);
        return gpaToMalaysianGrade(gpa);
      }
    } else if (conversionType === 'gpa') {
      const gpa = parseFloat(value);
      if (!isNaN(gpa) && gpa >= 0 && gpa <= 4) {
        return gpaToMalaysianGrade(gpa);
      }
    }
    return 'Invalid input';
  };
  const handleCalculateClick = () => {
    const converted = calculateConversion(originalValue);
    setConvertedValue(converted);
    setShowResult(true);
    setError(null);
  };
  const handleConversionTypeChange = (newConversionType) => {
    setConversionType(newConversionType);
    setOriginalValue('');
    setConvertedValue('');
    setShowResult(false);
    setError(null);
  };
  return (
    <div>
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
        <div className="col-12 col-md-4 text-center">
          <img src={imageUrl} alt={TITLE} width="350" height="auto" />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px' }}>
            <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Unlock the simplicity of converting your university GPA (whether it's a percentage or cumulative) to the Malaysian grading system with ease and precision using our advanced <strong>GPA conversion tool</strong>. This reliable tool helps you <strong>convert GPA to the Malaysian system</strong> effortlessly, ensuring you accurately understand how your academic performance aligns with Malaysian standards. Whether you're a student transitioning to study in Malaysia or need to convert your grades for academic or professional reasons, our <strong>GPA calculator</strong> offers quick and precise results. Dive into the details of the <strong>Malaysian university grading system</strong> and use our <strong>GPA conversion tool</strong> to make informed decisions about your educational path. This tool is essential for anyone looking to compare their GPA internationally and adapt to the Malaysian academic framework with confidence.
                </p>
              </div>
              <br />
            </div>
            <hr />
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: '16px' }}>Convert GPA to Malaysian Grading System</h2>
                </div>
                <hr />
                <div className="form-group">
                  <b><label>Conversion Type:</label></b>
                  <div>
                    <input
                      type="radio"
                      id="gradeConversion"
                      name="conversionType"
                      value="grade"
                      checked={conversionType === 'grade'}
                      onChange={() => handleConversionTypeChange('grade')}
                      className="form-check-input"
                      style={{ marginLeft: '4px' }}
                    />
                    <label htmlFor="gradeConversion" className="form-check-label">Percentage (100)</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="gpaConversion"
                      name="conversionType"
                      value="gpa"
                      checked={conversionType === 'gpa'}
                      onChange={() => handleConversionTypeChange('gpa')}
                      className="form-check-input"
                      style={{ marginLeft: '4px' }}
                    />
                    <label htmlFor="gpaConversion" className="form-check-label">Cumulative (4.00)</label>
                  </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b><label htmlFor="originalValue">{conversionType === 'grade' ? 'Percentage:' : 'Cumulative GPA:'}</label></b>
                  <input
                    type="text"
                    value={originalValue}
                    id="originalValue"
                    onChange={(e) => setOriginalValue(e.target.value)}
                    className="form-control"
                    style={{ width: '200px', marginRight: '4px' }}
                  />
                  <button
                    className="btn btn-success mt-2"
                    onClick={handleCalculateClick}
                  >
                    Calculate
                  </button>
                </div>
                {error && <div className="alert alert-danger mt-2"><b><u>Error:</u></b> {error}</div>}
                {showResult &&  (
                  <div style={{ fontSize: '15px' }} className="bg-light bg-gradient text-dark mt-3 p-2">
                    <div className="p-2 bg-success bg-gradient text-white">
                      <strong>Result:</strong>
                    </div>
                    <b>
                      {conversionType === 'grade'
                        ? `Malaysian grade: ${convertedValue}`
                        : `Malaysian grade for cumulative GPA: ${convertedValue}`}
                    </b>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={600} />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: 'auto' }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u><h2 style={{ fontSize: '16px' }}>Malaysian University Grading System</h2></u>
                  <p>
                    In Malaysia, university grades are classified on a scale from A to F, with A being the best and F being the worst. The grades are divided as follows:
                  </p>
                  <table >
                    <thead>
                      <tr className="bmi-header">
                        <th>U.S. Grade (out of 100)</th>
                        <th>Equivalent Percentage</th>
                        <th>GPA Value</th>
                        <th>Malaysian Grade</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>A</td>
                        <td>93-96%</td>
                        <td>4.0</td>
                        <td>A</td>
                      </tr>
                      <tr>
                        <td>A-</td>
                        <td>90-92%</td>
                        <td>3.67</td>
                        <td>A-</td>
                      </tr>
                      <tr>
                        <td>B+</td>
                        <td>87-89%</td>
                        <td>3.33</td>
                        <td>B+</td>
                      </tr>
                      <tr>
                        <td>B</td>
                        <td>83-86%</td>
                        <td>3.00</td>
                        <td>B</td>
                      </tr>
                      <tr>
                        <td>B-</td>
                        <td>80-82%</td>
                        <td>2.67</td>
                        <td>B-</td>
                      </tr>
                      <tr>
                        <td>C+</td>
                        <td>77-79%</td>
                        <td>2.33</td>
                        <td>C+</td>
                      </tr>
                      <tr>
                        <td>C</td>
                        <td>73-76%</td>
                        <td>2.00</td>
                        <td>C</td>
                      </tr>
                      <tr>
                        <td>C-</td>
                        <td>70-72%</td>
                        <td>1.67</td>
                        <td>C-</td>
                      </tr>
                      <tr>
                        <td>D+</td>
                        <td>67-69%</td>
                        <td>1.33</td>
                        <td>D+</td>
                      </tr>
                      <tr>
                        <td>D</td>
                        <td>65-66%</td>
                        <td>1.00</td>
                        <td>D</td>
                      </tr>
                      <tr>
                        <td>F</td>
                        <td>0-64%</td>
                        <td>0.0</td>
                        <td>F</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>
                    This information helps in understanding how to convert GPAs to the Malaysian system and know their equivalents in English and percentage terms.
                  </p>
                  <b className="text-primary">
                    <span>Example: </span>
                    If you have a cumulative GPA of 3.0 on a 4.0 scale, you can convert it to the Malaysian system using the tool above and get the equivalent result.
                  </b>
                  <p>
                    This tool is very useful for international students who wish to continue their studies in Malaysia or apply for jobs that require a specific GPA.
                  </p>
                  <div>
                    <p>
                      Malaysia is one of the scientifically advanced countries with many prestigious universities that attract students from all over the world.
                    </p>
                    <p className="alert alert-info">
                      Malaysia has many globally ranked universities, and the academic system in Malaysian universities is known for its scientific rigor and innovative curricula. The tuition fees in Malaysia are reasonable compared to other European countries and the United States.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  );
}
export default GpaToMalaysia;
